import { Button, Icon } from '@pairy/pds-react';

import { SetState } from '../../../../../types/helper';

import * as Styled from './index.styles';

interface Props {
  setIsMobileDrawerOpen: SetState<boolean>;
  translateKoToEn: (item: string) => string;
}
const CloseButton = ({ setIsMobileDrawerOpen, translateKoToEn }: Props) => {
  return (
    <Styled.CloseWrapper>
      <Button
        radius={9999}
        paddingX={12}
        paddingY={12}
        textVariant="sm-semibold"
        color="black"
        variant="zinc_500"
        rightIcon={<Icon icon="ph:caret-down" size={19} color="black" />}
        onClick={(e) => {
          e.stopPropagation();

          setIsMobileDrawerOpen(false);
        }}
      >
        {translateKoToEn('mobile-pageList-close')}
      </Button>
    </Styled.CloseWrapper>
  );
};

export default CloseButton;
